import type {ApiRequestOptions} from './types';

import {DEFAULT_OPTIONS} from './constants';

export const prepareOptions = (
  options: ApiRequestOptions = DEFAULT_OPTIONS,
) => {
  const result = {...options};

  Object.keys(DEFAULT_OPTIONS).forEach(key => {
    if (options[key] === undefined) {
      result[key] = DEFAULT_OPTIONS[key];
    }
  });

  return result;
};
